/**
 * Build SPA location for in-app / dashboard activity notifications from metadata + type.
 */
export function getNotificationDestination(type, metadata = {}) {
  const m = metadata || {};
  if (m.meeting_id) {
    return { pathname: '/meetings', search: `?highlight=${encodeURIComponent(m.meeting_id)}` };
  }
  if (m.maintenance_id) {
    return { pathname: '/maintenance', search: `?highlight=${encodeURIComponent(m.maintenance_id)}` };
  }
  if (m.property_id && (type || '').includes('payment')) {
    return { pathname: '/finances', search: `?property=${encodeURIComponent(m.property_id)}` };
  }
  if (m.property_id) {
    return { pathname: '/properties', search: `?highlight=${encodeURIComponent(m.property_id)}` };
  }
  if (m.document_id) {
    return { pathname: '/documents', search: `?document=${encodeURIComponent(m.document_id)}` };
  }
  if (m.finance_id) {
    return { pathname: '/finances', search: `?highlight=${encodeURIComponent(m.finance_id)}` };
  }
  if ((type || '').includes('meeting')) {
    return { pathname: '/meetings' };
  }
  if ((type || '').includes('maintenance')) {
    return { pathname: '/maintenance' };
  }
  if ((type || '').includes('payment')) {
    return { pathname: '/finances' };
  }
  return { pathname: '/dashboard' };
}
